import { render, staticRenderFns } from "./ScarList.vue?vue&type=template&id=559f4ac8&scoped=true"
import script from "./ScarList.vue?vue&type=script&lang=js"
export * from "./ScarList.vue?vue&type=script&lang=js"
import style0 from "./ScarList.vue?vue&type=style&index=0&id=559f4ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f4ac8",
  null
  
)

export default component.exports